import {
	IKhoanNopGroupSelectByHocSinhRequest
} from '../../../api/dich-vu/khoanNopGroupApi';
import {
	ISaleSetRegisterDichVuInsertMultipleRequest
} from '../../../api/dich-vu/saleSetRegisterDichVuApi';
import { IDichVuSelectRequest } from '../../../models/request/dich-vu/dichVuRequests';
import { KhoanNopStatusItemResponse } from '../../../models/response/dich-vu/sf_khoannop_group';
import { SaleSetRegisterDichVuItemResponse } from '../../../models/response/dich-vu/sf_saleset_register_dichvu';

export enum eSaleSetRegisterDichVuActionTypeIds {
	LOAD_START = "SALESET_REGISTER_DICHVU_LOAD_START",
	LOAD_SUCCESS = "SALESET_REGISTER_DICHVU_LOAD_SUCCESS",
	LOAD_ERROR = "SALESET_REGISTER_DICHVU_LOAD_ERROR",

	LOAD_KHOANNOP_BY_HOCSINH_START = "SALESET_REGISTER_DICHVU_LOAD_KHOANNOP_BY_HOCSINH_START",
	LOAD_KHOANNOP_BY_HOCSINH_SUCCESS = "SALESET_REGISTER_DICHVU_LOAD_KHOANNOP_BY_HOCSINH_SUCCESS",
	LOAD_KHOANNOP_BY_HOCSINH_ERROR = "SALESET_REGISTER_DICHVU_LOAD_KHOANNOP_BY_HOCSINH_ERROR",

	CHANGE_KHOANNOP_BY_HOCSINH = "SALESET_REGISTER_DICHVU_CHANGE_KHOANNOP_BY_HOCSINH",

	SHOW_DETAIL = "SALESET_REGISTER_DICHVU_SHOW_DETAIL",
	CLOSE_DETAIL = "SALESET_REGISTER_DICHVU_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "SALESET_REGISTER_DICHVU_CHANGE_SELECTED_IDS",

	SAVE_START = "SALESET_REGISTER_DICHVU_SAVE_START",
	SAVE_SUCCESS = "SALESET_REGISTER_DICHVU_SAVE_SUCCESS",
	SAVE_ERROR = "SALESET_REGISTER_DICHVU_SAVE_ERROR"
}

export interface ISaleSetRegisterDichVuLoadStart {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_START,
	payload: IDichVuSelectRequest
}
export interface ISaleSetRegisterDichVuLoadSuccess {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_SUCCESS,
	payload: SaleSetRegisterDichVuItemResponse[]
}
export interface ISaleSetRegisterDichVuLoadErr {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IKhoanNopGroupByHocSinhLoadStart {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_START,
	payload: IKhoanNopGroupSelectByHocSinhRequest
}
export interface IKhoanNopGroupByHocSinhLoadSuccess {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_SUCCESS,
	payload: KhoanNopStatusItemResponse[]
}
export interface IKhoanNopGroupByHocSinhLoadErr {
	type: eSaleSetRegisterDichVuActionTypeIds.LOAD_KHOANNOP_BY_HOCSINH_ERROR,
	payload: string
}
export interface IKhoanNopGroupByHocSinhChange {
	type: eSaleSetRegisterDichVuActionTypeIds.CHANGE_KHOANNOP_BY_HOCSINH,
	payload: KhoanNopStatusItemResponse[]
}
export interface ISaleSetRegisterDichVuShowDetail {
	type: eSaleSetRegisterDichVuActionTypeIds.SHOW_DETAIL,
	payload?: SaleSetRegisterDichVuItemResponse
}
export interface ISaleSetRegisterDichVuCloseDetail {
	type: eSaleSetRegisterDichVuActionTypeIds.CLOSE_DETAIL
}
export interface ISaleSetRegisterDichVuChangeSelectedIds {
	type: eSaleSetRegisterDichVuActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface ISaleSetRegisterDichVuSaveStart {
	type: eSaleSetRegisterDichVuActionTypeIds.SAVE_START,
	payload: ISaleSetRegisterDichVuInsertMultipleRequest
}
export interface ISaleSetRegisterDichVuSaveSuccess {
	type: eSaleSetRegisterDichVuActionTypeIds.SAVE_SUCCESS
}
export interface ISaleSetRegisterDichVuSaveErr {
	type: eSaleSetRegisterDichVuActionTypeIds.SAVE_ERROR,
	payload: string
}

export type ISaleSetRegisterDichVuActionTypes = ISaleSetRegisterDichVuLoadStart | ISaleSetRegisterDichVuLoadSuccess | ISaleSetRegisterDichVuLoadErr |
	IKhoanNopGroupByHocSinhLoadStart | IKhoanNopGroupByHocSinhLoadSuccess | IKhoanNopGroupByHocSinhLoadErr |
	IKhoanNopGroupByHocSinhChange |
	ISaleSetRegisterDichVuShowDetail | ISaleSetRegisterDichVuCloseDetail |
	ISaleSetRegisterDichVuChangeSelectedIds |
	ISaleSetRegisterDichVuSaveStart | ISaleSetRegisterDichVuSaveSuccess | ISaleSetRegisterDichVuSaveErr
